import { Injectable } from '@angular/core';
import {
    PresentacionProductoComercializador,
    ProductoComercializador,
} from '../interfaces/producto-comercializador.interface';
import { RegistroService } from 'src/app/registro.service';

/**
 * Servicio de utilidades para productos comercializadores
 * @since 1.0.0
 */
@Injectable({
    providedIn: 'root',
})
export class ProductUtilsService {
    constructor(private readonly registroService: RegistroService) {}

    /** Mapa de colores por tipo de producto */
    private readonly coloresPorTipo: { [key: number]: string } = {
        1: '#3498db',
        2: '#27ae60',
        3: '#e74c3c',
        4: '#f39c12',
    };

    /**
     * Genera descripción formateada del producto
     * @param producto - Presentación del producto
     * @returns Descripción legible del producto
     */
    generarDescripcionProducto(
        producto: PresentacionProductoComercializador
    ): string {
        const registroIca = producto.productoComercializador.numeroRegistroIca;
        const nombreComercial =
            producto.productoComercializador.nombreComercial;
        const cantidad = producto.cantidad;
        const unidad = producto.unidadMedida.abreviacion;
        const empaque = producto.empaque.nombre;

        return `${registroIca}-${nombreComercial} - ${empaque} ${cantidad} ${unidad}  `;
    }

    /**
     * Obtiene color hexadecimal por tipo de producto
     * @param tipoId - ID del tipo de producto
     * @returns Color hexadecimal
     */
    obtenerColorPorTipo(tipoId: number): string {
        return this.coloresPorTipo[tipoId] || '#95a5a6';
    }

    /**
     * Obtiene información detallada del producto
     * @param producto - Presentación del producto
     * @returns String con información formateada
     */
    obtenerInformacionProducto(
        producto: PresentacionProductoComercializador
    ): string {
        if (!producto.productoComercializador) return '';

        return `
      Tipo: ${producto.productoComercializador.tipoProducto?.nombre || 'N/A'}
      Subgrupo: ${producto.productoComercializador.subgrupo}
      Unidad: ${producto.unidadMedida?.nombre || 'N/A'}
      Empaque: ${producto.empaque?.nombre || 'N/A'}
      Estado: ${producto.estado}
    `
            .trim()
            .replace(/\s+/g, ' ');
    }

    /**
     * Prepara datos de productos para enviar al backend
     * @param productos - Array de productos seleccionados
     * @returns Array de datos formateados
     */
    prepararDatosParaGuardar(productos: ProductoComercializador[]): any[] {
        return productos.map((producto) => ({
            presentacionComercializadorId: producto.id,
            agenteVigiladoId: Number(this.registroService.empresaSelected),
            estado: 'activo',
        }));
    }
}
